/**
 * INFO: Fetches advanced_ai quota preview for dashboard + date range (subscriptions API).
 */
export async function fetchAiInsightsQuota(apiRequest, {
  dashboardId,
  startDate,
  endDate,
}) {
  if (!dashboardId || !startDate || !endDate) {
    console.warn(
      "[WARN] fetchAiInsightsQuota skipped: missing dashboardId or date range",
    );
    return null;
  }
  const payload = {
    quota_type: "advanced_ai",
    dashboard_ids: [String(dashboardId)],
    start_date: startDate,
    end_date: endDate,
  };
  return apiRequest(
    "subscriptions/check_quota_for_target_params",
    "POST",
    payload,
    true,
  );
}
